import styled from '@emotion/styled';

const FamilyMemberContainer = styled('div')(({ theme }) => ({
  borderBottom: `0.1rem solid ${theme.colors.gray.primary}`,
  borderLeft: `0.1rem solid ${theme.colors.gray.primary}`,
  borderRight: `0.1rem solid ${theme.colors.gray.primary}`,
}));

export default FamilyMemberContainer;
